<section class="card">
  <div class="card-body">
    <div class="danger-zone">
      <div class="danger-summary" (click)="toggleExpanded()">
        <span class="me-2">Danger zone</span>
        <span class="chevron" [class.open]="expanded" aria-hidden="true"></span>
      </div>
      @if (expanded) {
        <div class="mt-2">
          <p class="text-muted small mb-2">
            This permanently deletes the "{{ config.dataSource }}" data source for the selected partition.
          </p>
          <div class="d-grid">
            <button
              class="btn btn-outline-danger"
              [disabled]="deleting"
              (click)="deleteDataSource()"
            >
              Delete Data Source
            </button>
          </div>
          @if (status) {
            <p class="status-text small mt-2 mb-0" [class]="statusClass" role="status" aria-live="polite">
              {{ status }}
            </p>
          }
          <hr class="my-3" />
          <p class="text-muted small mb-2">
            This deletes only the target sets for the "{{ config.dataSource }}" data source, leaving wells, wellbores, and trajectories intact.
          </p>
          <div class="d-grid">
            <button
              class="btn btn-outline-danger"
              [disabled]="deletingTargets"
              (click)="deleteTargets()"
            >
              Delete Targets
            </button>
          </div>
          @if (targetsStatus) {
            <p class="status-text small mt-2 mb-0" [class]="targetsStatusClass" role="status" aria-live="polite">
              {{ targetsStatus }}
            </p>
          }
        </div>
      }
    </div>
  </div>
</section>
